// extracted by mini-css-extract-plugin
module.exports = {"root":"bt-5BnY","flex":"snxk1oN","textFound":"_3mgbOLD"};
    if(module.hot) {
      // 1545369435531
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  